export const darkGrey = 'rgba(0, 0, 0, 0.54)'
export const lightGrey = 'rgba(229,229,229)'
export const disabledGrey = 'rgba(0, 0, 0, 0.38)'
export const darkLightError = 'rgba(183, 61, 59, 1)'
export const borderGreyColor = 'rgba(185,185,185)'
export const lightError = 'rgba(250, 107, 91, 1)'
export const white = 'rgba(255, 255, 255, 1)'

export const alertDetails = 'rgb(235 220 220)'

export const ErrorBackground = '#FF000026'
export const ErrorBackgroundHover = '#FF000020'

export const InfoBackground = '#eef2fb'
export const InfoBackgroundHover = '#f4f7fc'

export const ClipBoardIconColor = '#CDCDCD'

export const RoyalBlue = '#2c5ed7'
export const SandBeige = 'rgb(236, 218, 180)'
export const GrassGreen = '#45AD06'
export const DangerRed = '#FF0303'
export const SlateGrey = '#606060'
export const AshGrey = '#C4C4C4'
export const Alabaster = '#f5f5f5'
